import React from 'react';

import styles from './DeliveryCourierAddress.module.css'

import {Input} from "../../../../../../../../ui/DataEntry/Input/Input.tsx";
import {cn} from "../../../../../../../../utils/cn.ts";
import {Order} from "../../../../../../../../types/Order.interface.ts";
import {Map, Placemark, YMaps} from "@pbe/react-yandex-maps";

interface Props {
    offer: Order,
}

export const DeliveryCourierAddress: React.FC<Props> = ({offer}) => {
    const street = offer.delivery.street || '';
    const streetNumber = offer.delivery.house || '';
    const apartmentNumber = offer.delivery.apartment || '';
    const longitude = offer.delivery.longitude || '';
    const latitude = offer.delivery.latitude || '';

    return (
        <div>
            <div style={{marginBottom: 12,}}>
                <h4 className={styles.title}>Адрес доставки</h4>
                <div className={styles.inputs}>
                    <Input
                        className={cn(styles.input, styles.street)}
                        label='Улица'
                        value={street}
                        disabled={true}
                    />
                    <Input
                        className={cn(styles.input, styles.streetNumber)}
                        label='Дом'
                        value={streetNumber}
                        disabled={true}
                    />
                    <Input
                        className={cn(styles.input, styles.apartmentNumber)}
                        label='Кв./Офис'
                        value={apartmentNumber}
                        disabled={true}
                    />
                </div>
            </div>
            <div>
                {
                    latitude && longitude
                    ? <YMaps>
                        <Map
                            defaultState={{
                                zoom: 16,
                                controls: [],
                                center: [latitude, longitude],
                            }}
                            width="100%"
                            height={485}
                        >
                                <Placemark
                                    modules={["geoObject.addon.balloon"]}
                                    defaultGeometry={[latitude, longitude]}
                                />
                        </Map>
                    </YMaps>
                    : null
                }
            </div>
        </div>
    );
};